const update = (service, entry, deletestatus) => {
  // console.log('update-field', entry)
  return {
    type: 'Update > ' + service,
    payload: entry,
    deletestatus
  }
}
module.exports = update



// WEBPACK FOOTER //
// ./src/actions/update-field.js